import React from 'react'
import cls from 'classnames'

import classes from './Button.module.scss'

export default function Button(props) {
	return (
		<div
			className={cls('btn-group btn-group-lg', classes.ButtonContainer)}
			role='group'
		>
			<button
				className={cls('btn', classes.Button, props.className)}
				disabled={props.isDisabled}
				onClick={props.onClick}
			>
				{props.label}
			</button>
		</div>
	)
}